import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { useAccountScoreNotification } from 'features/accountPlatforms/hooks/useAccountScoreNotification';
import OrganizationOnboarding from 'features/organizations/pages/OrganizationOnboarding';

import { LinkCreator } from 'shared/utilities/linkUtility';

import OnboardingWrapper from './OnboardingWrapper';
import { ALL_ROUTES } from 'shared/config/routes/generalRoutes';

export const CONTACT_US_URL = 'https://www.brkfst.io/contact-us/';

const BrandOnboardingRoutes: React.FC = () => {
  useAccountScoreNotification();
  const location = useLocation<any>();

  // We no longer want new marketers to go through onboarding process, and instead go to our contact us page
  // BRKFST-1289
  useEffect(() => {
    if (location.pathname.includes(ALL_ROUTES.BRANDS.ORGANIZATION_ONBOARDING)) {
      window.location.assign(CONTACT_US_URL);
    }
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/org-onboarding" />} />
      <Route element={<OnboardingWrapper />}>
        <Route path="/org-onboarding" element={<OrganizationOnboarding />} />
        <Route element={<Navigate to={LinkCreator.createLink({ routeKey: 'NOT_FOUND' })} />} />
      </Route>
    </Routes>
  );
};

export default BrandOnboardingRoutes;
